import React from 'react';
import { isMockId } from '@gp/utils/common';

export const buildSelectMultipleButtonRenderer = (props?: {
  placeholder: string;
  allOption?: false | IGPSelectOptionWithGroup;
  options?: IGPSelectOptionWithGroup[] | null;
}) => {
  const { placeholder, allOption, options } = props || {};
  return (selectedOptions?: IGPSelectOptionWithGroup[] | null): React.ReactElement => {
    if (!Array.isArray(selectedOptions) || !selectedOptions.length)
      return <div className="dbg-text-overflow-ellipsis dbg-text-placeholder">{placeholder}</div>;
    if (allOption !== false && allOption?.text && selectedOptions.length === options?.length)
      return <div className="dbg-text-overflow-ellipsis">{allOption.text}</div>;
    return (
      <div className="dbg-text-overflow-ellipsis">
        {selectedOptions.map((selectedOption) => selectedOption?.label).join(', ')}
      </div>
    );
  };
};

export const formatPlatformsReq = (platforms?: string[]): string => {
  if (!Array.isArray(platforms) || !platforms.length) return '';
  return platforms.length === 3 ? 'All platforms' : platforms.join(',');
};

export const formatEngineRes = (engine?: any, engineOptional?: any): any => {
  if (!Array.isArray(engine) || !engine.length) return [];

  const arrengine = engineOptional
    ?.filter((item: any) => engine.includes(item.id))
    ?.map((subItem: any) => {
      return { id: isMockId(subItem.id) ? '' : subItem.id, tag: subItem.tag };
    });

  return arrengine || [];
};

export const formatengineOptionalRes = (engineOptional?: any): any => {
  if (!Array.isArray(engineOptional) || !engineOptional.length) return [];
  const arrengine = engineOptional?.map((subItem: any) => {
    return { id: isMockId(subItem.id) ? '' : subItem.id, tag: subItem.tag };
  });
  return arrengine || [];
};
